import { ref, reactive } from 'vue';
import { userApi } from '@/api';
import type { ICurrentUser } from '@/types';

const loadingCurrentUser = ref(false);
const isCompanyAdmin = ref(false);
const isSuperAdmin = ref(false);

const currentUser: ICurrentUser = reactive({
  email: '',
  name: '',
  given_name: '',
  family_name: '',
  federationFirstName: '',
  federationLastName: ''
});

async function getCurrentUser() {
  loadingCurrentUser.value = true;
  try {
    const response = await userApi.getUser();
    Object.assign(currentUser, response?.data);
    return response;
  } catch (error) {
    console.info('getUser error', error);
  } finally {
    loadingCurrentUser.value = false;
  }
}

export function useCurrentUser() {
  return {
    currentUser,
    loadingCurrentUser,
    isCompanyAdmin,
    isSuperAdmin,
    getCurrentUser
  };
}
